import { MeetingService } from './src/services/meeting.service';

export type { ConfiguracionMeeting } from './src/services/suite.interfaces';

export const meetingService = new MeetingService();

export default meetingService;
